import { Auth, AuthResponse } from "../models/Auth";
import { Api, getBaseUrl, getResponseData, ModelRes } from "./utils";

export const login = (user: Auth): Promise<ModelRes<AuthResponse>> =>
  Api.post("/auth/login", user).then(getResponseData);

export const logout = () => Api.post("/auth/logout");

export const getCurrentUser = () => Api.post(`${getBaseUrl()}/users/me`).then(getResponseData);;
